// extracted by mini-css-extract-plugin
export default {"icon":"RespIcon_icon__6W06t","badge":"RespIcon_badge__zqX6J","sm":"RespIcon_sm__7mer+","md":"RespIcon_md__5iyp4","lg":"RespIcon_lg__y6-pT"};